export const translation = {
  connecting: "Connexion...",
  offline: {
    title: "Désolé !",
    message: "Il n'y a pas de quiz en cours pour le moment."
  },
  video: {
    tapToUnmute: "Appuyez pour réactiver le son",
    tryVideoAgain: "Réessayer la vidéo"
  },
  countdown: {
    soon: "Bientôt...",
    aboutToStart: "Commence bientôt...",
    kickOff: "Coup d'envoi"
  },
  join: {
    instruction: "Participez au quiz !",
    joinInNow: "Participez dès maintenant !",
    screenName: "Nom d'écran",
    enterScreenName: "Saisissez votre nom d'écran",
    button: {
      join: "Rejoindre",
      next: "Suivant"
    },
    chooseTeam: "Choisir une équipe à rejoindre",
    hello: "Bonjour",
    vs: "– vs –",
    player: "Joueur",
    players: "Joueurs"
  },
  form: {
    name: "Nom",
    email: "Courriel",
    mobile: "Mobile",
    iAgreeToThe: "J'accepte les <0>{{terms}}</0>",
    terms: "conditions générales",
    termsLink: "https://piing.events/terms-quiiz",
    privacyPolicy: "Politique de confidentialité",
    privacyPolicies: "Politiques de confidentialité",
    privacyLink: "https://piing.events/privacy",
    ok: "OK"
  },
  errorBoundary: {
    connectionErrorTitle: "Désolé, nous avons eu des difficultés à vous connecter",
    connectionError: "S'il vous plaît <0>{{tryAgain1}}</0>",
    notConnectionErrorTitle: "Désolé, une erreur s'est produite",
    notConnectionError: "S'il vous plaît <0>{{tryAgain2}}</0> ou <1>{{contactUs}}</1> pour signaler ce problème",
    tryAgain1: "Réessayez",
    tryAgain2: "Réessayez",
    contactUs: "nous contacter",
    emailSubject: "Signaler un problème avec Quiiz",
    emailBody: "Veuillez décrire ce qui s’est passé ci-dessous"
  },
  validation: {
    nameTaken: "Ce nom est déjà pris !",
    problemJoining: "Il y a eu un problème pour rejoindre le jeu",
    notReadyForPlayers: "Nous ne sommes pas encore prêts pour les joueurs",
    checkName: "Veuillez cocher votre nom",
    checkEmail: "Veuillez vérifier votre adresse électronique",
    checkMobile: "Veuillez vérifier votre numéro de téléphone portable",
  },
  leaderboard: {
    teamsLeaderboard: "Classement des équipes",
    playersLeaderboard: "Classement des joueurs",
    team: "Équipe",
    name: "Nom",
    score: "Score",
    bonus: "Bonus",
    wins: "gagne !",
    tab: {
      topPlayers: "Meilleurs joueurs",
      topTeams: "Meilleures équipes",
      yourTeam: "Votre équipe",
    }
  },
  score: {
    q: "Q",
    correct: "Correct",
    incorrect: "Incorrect",
    speedBonus: "Bonus de vitesse",
    team: "Équipe",
    overall: "Général",
    score: "Score",
    rank: "Classement",
  },
  question: {
    question: "Question",
    milliseconds: "ms",
  }
};